<app-toast></app-toast>
<app-spinner></app-spinner>
<main class="main">
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</main>
